// extracted by mini-css-extract-plugin
export default {"label":"donut-chart_label__GY+3l","chart":"donut-chart_chart__Kulru","opacity-transition":"donut-chart_opacity-transition__6u0Wi"};